function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 40,
  cy: 40,
  rx: 40,
  ry: 40,
  fill: "#f8cecc",
  stroke: "#b85450",
  pointerEvents: "all"
});

var _ref4 = /*#__PURE__*/React.createElement("text", {
  x: 40,
  y: 44,
  fill: "#000000",
  fontFamily: "Helvetica",
  fontSize: "12px",
  textAnchor: "middle"
}, "Calista");

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 200,
  cy: 40,
  rx: 40,
  ry: 40,
  fill: "#f8cecc",
  stroke: "#b85450",
  pointerEvents: "all"
});

var _ref6 = /*#__PURE__*/React.createElement("text", {
  x: 200,
  y: 44,
  fill: "#000000",
  fontFamily: "Helvetica",
  fontSize: "12px",
  textAnchor: "middle"
}, "Rosie");

var _ref7 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 120,
  cy: 160,
  rx: 40,
  ry: 40,
  fill: "#dae8fc",
  stroke: "#6c8ebf",
  pointerEvents: "all"
});

var _ref8 = /*#__PURE__*/React.createElement("text", {
  x: 120,
  y: 164,
  fill: "#000000",
  fontFamily: "Helvetica",
  fontSize: "12px",
  textAnchor: "middle"
}, "Bennie");

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M 71.42 73.83 L 100.44 125.11",
  fill: "none",
  stroke: "#000000",
  strokeMiterlimit: 10,
  pointerEvents: "stroke"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M 68.83 69.26 L 75.33 73.63 L 71.42 73.83 L 69.24 77.07 Z",
  fill: "#000000",
  stroke: "#000000",
  strokeMiterlimit: 10,
  pointerEvents: "all"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M 177.9 73.34 L 145.73 121.43",
  fill: "none",
  stroke: "#000000",
  strokeMiterlimit: 10,
  pointerEvents: "stroke"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M 142.81 125.79 L 143.79 118.02 L 145.73 121.43 L 149.61 121.92 Z",
  fill: "#000000",
  stroke: "#000000",
  strokeMiterlimit: 10,
  pointerEvents: "all"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M 80 40 L 153.63 40",
  fill: "none",
  stroke: "#000000",
  strokeMiterlimit: 10,
  pointerEvents: "stroke"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M 158.88 40 L 151.88 43.5 L 153.63 40 L 151.88 36.5 Z",
  fill: "#000000",
  stroke: "#000000",
  strokeMiterlimit: 10,
  pointerEvents: "all"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 105,
  y: 70,
  width: 30,
  height: 20,
  fill: "none",
  stroke: "none",
  pointerEvents: "all"
});

var _ref16 = /*#__PURE__*/React.createElement("text", {
  x: 120,
  y: 84,
  fill: "#000000",
  fontFamily: "Helvetica",
  fontSize: "12px",
  textAnchor: "middle"
}, "?");

var _ref17 = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
  requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
}), /*#__PURE__*/React.createElement("a", {
  transform: "translate(0,-5)",
  xlinkHref: "https://desk.draw.io/support/solutions/articles/16000042487",
  target: "_blank"
}, /*#__PURE__*/React.createElement("text", {
  textAnchor: "middle",
  fontSize: "10px",
  x: "50%",
  y: "100%"
}, "Viewer does not support full SVG 1.1")));

var SvgParadoxicalTournament = function SvgParadoxicalTournament(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "241px",
    height: "201px",
    viewBox: "-0.5 -0.5 241 201",
    content: "<mxfile host=\"app.diagrams.net\" modified=\"2020-08-07T01:46:42.824Z\" agent=\"5.0 (Macintosh; Intel Mac OS X 10_15_5) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/84.0.4147.105 Safari/537.36\" etag=\"T4MxsXitSp45diAZGZ5q\" version=\"13.6.0\" type=\"device\"><diagram id=\"Ra3Fi83U9BzJdPZ0KHpK\" name=\"Page-1\">7VjbctowEP0aHmFkyTbmMUAg006mmZKZpo/CFrYmwnJlES5fXwnL2DLOhYQ0aadPSGfllXbP8WpNB42Wm6nAWXLNI8I6EESbDhp3IHRc6KsfjWwLpK9nGogFjcyiCpjRHTEgMOiKRiS3FkrOmaSZDYY8TUkoLQwLwdf2sgVn9q4ZjskRMAsxO0Z/0EgmBRp4oMKvCI2TcmcHGMsSl4sNkCc44usahC47aCQ4l8VouRkRppNX5qV4bvKI9XAwQVL5kgeud6N1cDX5mtyub24Xw93dzpl2jZcHzFYm4A70mfI3XHDlVp1abk0q/F8rXhq6+Z6oC7XA8bNNZVSjWP+OMKO5xKUzdarCX2E1CTm4huqkilA1Ga4TKsksw6G2rJWmFJbIJVMzRw1xnhUsL+iGRPo0lLERZ1zsHaFFEJIwVHguBb8nNcs88FzFWrl5PW9lEoiQZFODTB6nhC+JFFu1xFhhYDg1onZ8M1/XJGKgpKaOEsNGlPHBc8WbGhjqTqARvhON33lOyT9Kout+MhLRO5E4JGn6ASxGmASLVhb9MCDzxXlYRL7N4oGej2LRb2GxmeI0utBXk5qlPCV2WsmGyrva+GdtPNZBg3KyNRNVZ4UsHYYM5zkNS3hC2cFxGpnZky9QzlciJM9fGcp7TOTzciaRdcEeE1kjymshqsQEYVjSB/tabmPP7HDD6f6lKXUCGjpBDQEUcZun6tdo05FnO0Kw4ahIzJGjvZgOYb9eX8FJ+qrkUJOYJRijwLpagKUW501qgX+nWhzYU62rC/yg7zgDOOg3xNNuPllL/aDn+kpRXh8AJ3AAsqWFgt7A89HAC6ALgAv/qNAG5xCarvxl3/xYdQM978n6ZkvxJeJ9c3H7LDKEtiAgeGXRavY6R47OpyU0nHTH8X3Wdb98205FOE9n2Ws+M3QLQNV3WFd9ScRp0d/QNCGC6vV7kkGj/VGUt7Q//3d6005o8mjneBa4UVJU2ycbfWYRwThULzMRtdgujGFJo0g/PhRERYPne1c6xkzLeS9wb9jxxtrXSvIi4qevtRP6z8Br7ytqFQK1VIhm1/CC/lNNq38Lijez+s8FXf4G</diagram></mxfile>",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, _ref3, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 40,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 16
    }
  }, "Calista"))))), _ref4)), _ref5, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 40,
      marginLeft: 161
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 16
    }
  }, "Rosie"))))), _ref6)), _ref7, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 160,
      marginLeft: 81
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 16
    }
  }, "Bennie"))))), _ref8)), _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 80,
      marginLeft: 120
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      verticalAlign: "inherit",
      fontSize: 20
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      verticalAlign: "inherit",
      fontSize: 20
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      verticalAlign: "inherit",
      fontSize: 20
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      verticalAlign: "inherit",
      fontSize: 20
    }
  }, "?")))))))), _ref16))), _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgParadoxicalTournament, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paradoxical-tournament.46328a49.svg";
export { ForwardRef as ReactComponent };